export default {
  title: "My App"
};
